module.exports = __webpack_public_path__ + "index/img/wode.c4a7777f.png";